import { render, staticRenderFns } from "./add-new-customer.vue?vue&type=template&id=0df4908d&"
import script from "./add-new-customer.vue?vue&type=script&lang=js&"
export * from "./add-new-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports